import { Link } from "react-router-dom";
import { PageEnum, TABLEPAI, SOFT_GRID } from "@/enums/pageEnum";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { BasicTable, PageTitle, HView } from "@/components";
import { getTimeToString } from "@/utils/toolt";

export default function TypeSettingPage() {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("type"),
      dataIndex: "type",
      renderText: (text: string) => <>{t(text)}</>,
    },
    { title: t("organizations"), dataIndex: "organizationCnt" },
    { title: t("permissions"), dataIndex: "permissionsCnt" },
    {
      title: t("editTime"),
      dataIndex: "editTime",
      renderText: (text: number) => <>{getTimeToString(text)}</>,
    },
    {
      title: t("action"),
      dataIndex: "action",
      renderText: (_: string, record: { type: string }) => {
        if (record?.type === SOFT_GRID) return "-";
        return (
          <>
            <HView
              name={t("view")}
              path={`${PageEnum.TYPESETTING}/detail/${record?.type}`}
              state={record}
            />
          </>
        );
      },
    },
  ];
  return (
    <div className="p-5">
      <PageTitle title={t("typeSetting")} />
      <Breadcrumb
        items={[
          {
            title: <Link to={PageEnum.ORGANIZATION}>{t("organization")}</Link>,
          },
          { title: t("typeSetting") },
        ]}
        className="mb-[2px] bg-[#fff] dark:bg-[#141414] p-4"
      />
      <BasicTable
        columns={columns}
        requestUrl={TABLEPAI.TYPES}
        isShowCheckbox={false}
        isPagination={false}
        rowKey="type"
        dataKey="data.body"
        isDefaultToolBar={false}
      />
    </div>
  );
}
